var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export var NsCollapsePanelModel;
(function (NsCollapsePanelModel) {
    NsCollapsePanelModel.id = 'COLLAPSE_PANEL_DATA';
    NsCollapsePanelModel.useModel = (model) => __awaiter(this, void 0, void 0, function* () {
        return model.awaitModel(NsCollapsePanelModel.id);
    });
})(NsCollapsePanelModel || (NsCollapsePanelModel = {}));
//# sourceMappingURL=interface.js.map